import { render } from "./ListLotto.vue?vue&type=template&id=23f64350&scoped=true"
import script from "./ListLotto.vue?vue&type=script&lang=js"
export * from "./ListLotto.vue?vue&type=script&lang=js"

import "./ListLotto.vue?vue&type=style&index=0&id=23f64350&scoped=true&lang=scss"

import exportComponent from "D:\\Work\\renny\\rotto-sale\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f64350"]])

export default __exports__